// extracted by mini-css-extract-plugin
export var subtitle = "_d8-2";
export var title = "_d8-0";
export var titleNoWrap = "_d8-1";